export default "__VITE_ASSET__CD2F9FYC__"